import { GridItem } from '@chakra-ui/react';
import { useState } from 'react';
import Select, { MultiValue } from 'react-select';
import { CustomOption, Field } from '@/components';
import { trans } from '@/i18n';
import { ISelect } from '@/types';

const statusFilters: ISelect = {
  label: 'ステータス',
  value: 'status',
  options: [
    {
      label: '表示',
      value: 'active',
    },
    {
      label: '非表示',
      value: 'inactive',
    },
  ],
};

interface IProps {
  onChange?: (newValue: MultiValue<ISelect>) => void;
}

function NoteFilter(props: IProps) {
  const [value, setValue] = useState<MultiValue<ISelect>>([]);
  return (
    <GridItem>
      <Field>
        <Select
          isMulti={true}
          closeMenuOnSelect={false}
          isClearable={true}
          placeholder={'フィルター'}
          options={[statusFilters]}
          value={value}
          onChange={(newValue) => {
            setValue(newValue || []);
            props?.onChange?.(newValue);
          }}
          noOptionsMessage={() => trans('shared.noOption')}
          menuPortalTarget={document.body}
          hideSelectedOptions={false}
          styles={{
            control: (styles) => ({
              ...styles,
              width: '260px',
              backgroundColor: 'white',
              borderRadius: 15,
              minHeight: '35px',
            }),
            indicatorSeparator: () => ({
              display: 'none',
            }),
          }}
          components={{
            Option: CustomOption,
          }}
        />
      </Field>
    </GridItem>
  );
}

export { NoteFilter };
